package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.ControlClass
import co.maytes.standupbot.dashboard.styles.Space
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input

@Composable
fun CopyField(
    value: String,
    modifier: Modifier = Modifier,
    label: String? = null,
    hint: String? = null,
    help: String? = null,
    size: ControlSize = ControlSize.Md,
    copyLabel: String = "Copy to clipboard",
    ariaLabel: String? = null,
) {
    val metrics = (if (size == ControlSize.Sm) ControlSize.Md else size).metrics
    val buttonSize = if (size == ControlSize.Lg) ControlSize.Md else ControlSize.Sm

    FormField(
        label = label,
        modifier = modifier,
        hint = hint,
        help = help,
        reserveMessageSpace = false,
    ) { field ->
        Div(
            attrs = Modifier
                .classNames(ControlClass.COPY_FIELD)
                .height(metrics.height)
                .styleModifier {
                    property("padding", "0 ${Space.s1} 0 ${metrics.padX}")
                }
                .toAttrs(),
        ) {
            Input(
                type = InputType.Text,
                attrs = Modifier
                    .classNames(ControlClass.COPY_FIELD_VALUE)
                    .fontSize(metrics.fontSize)
                    .styleModifier { property("height", "100%") }
                    .toAttrs {
                        value(value)
                        attr("readonly", "")
                        attr("spellcheck", "false")
                        attr("autocomplete", "off")
                        ariaLabel?.let { attr("aria-label", it) }
                        fieldControl(field)
                    },
            )
            CopyButton(text = value, ariaLabel = copyLabel, size = buttonSize)
        }
    }
}
